import { useGetIdentity } from "ra-core";

import { useEsAdmin } from "./useEsAdmin";

/**
 * Filtro del desplegable «Responsable» (Robert, 09/10/2026): Jan y Robert eligen entre los
 * usuarios activos; un setter solo se ve a sí mismo (no ve a los demás usuarios en ningún
 * desplegable, leyenda ni filtro).
 */
export const useFiltroAsignables = (): Record<string, unknown> => {
  const esAdmin = useEsAdmin();
  const { identity } = useGetIdentity();
  return esAdmin
    ? { disabled: false }
    : { disabled: false, id: identity?.id ?? 0 };
};
